import request from '@/utils/request'

export function getKdKdjlbList(data) {
  return request({
    url: '/api/Extend/LqKdKdjlb',
    method: 'get',
    data
  })
}

export function getKdKdjlbInfo(id) {
  return request({
    url: `/api/Extend/LqKdKdjlb/${id}`,
    method: 'get'
  })
}

export function createKdKdjlb(data) {
  return request({
    url: '/api/Extend/LqKdKdjlb',
    method: 'post',
    data
  })
}

/** 开单活动（套餐活动）列表 */
export function getPackageInfoList(data) {
  return request({
    url: '/api/Extend/lqpackageinfo/GetPackageInfoListAsync',
    method: 'get',
    data
  })
}

/** 合作/结算机构 */
export function getHzfList(data) {
  return request({
    url: '/api/Extend/LqHzf',
    method: 'get',
    data
  })
}
